import React, { useEffect, useState, useCallback } from 'react';
import { Edit, Add, ArrowBack, Search, Mail } from "@mui/icons-material";
import api from '../../services/api';
import styles from '../../assets/styles/LayoutShared.module.css';
import UsuarioForm from './UsuarioForm';

const UsuariosList = () => {
  const [usuarios, setUsuarios] = useState<any[]>([]);
  const [search, setSearch] = useState("");
  const [tempSearch, setTempSearch] = useState("");
  const [formOpen, setFormOpen] = useState(false);
  const [usuarioEditando, setUsuarioEditando] = useState<any>(null);
  const [mensagem, setMensagem] = useState('');
  const [mensagemErro, setMensagemErro] = useState(false);

  const fetchUsuarios = useCallback((searchTerm: string) => {
    api.get(`/pesca/usuarios?search=${searchTerm}`).then(res => {
      setUsuarios(res.data.data);
    });
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => setSearch(tempSearch), 500);
    return () => clearTimeout(handler);
  }, [tempSearch]);

  useEffect(() => {
    fetchUsuarios(search);
  }, [search, fetchUsuarios]);

  const handleNovo = () => {
    setUsuarioEditando(null);
    setFormOpen(true);
  };

  const handleEditar = (usuario: any) => {
    setUsuarioEditando(usuario);
    setFormOpen(true);
  };

  const handleReenviarConvite = async (usuario: any) => {
    try {
      await api.post(`/pesca/usuarios/${usuario.uid_usuario}/reenviar-convite`);
      setMensagem(`Convite reenviado para ${usuario.nome}.`);
      setMensagemErro(false);
    } catch (err: any) {
      setMensagem(err?.response?.data?.message || 'Erro ao reenviar convite.');
      setMensagemErro(true);
    }
    setTimeout(() => setMensagem(''), 5000);
  };

  const handleSalvo = () => {
    setFormOpen(false);
    fetchUsuarios(search);
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerTitle}>
        <h1 className={styles.greenTitle}>Usuários da Pesca</h1>

        <div style={{ position: 'relative', flex: 1, maxWidth: '400px', margin: '0 20px' }}>
          <Search style={{ position: 'absolute', left: '10px', top: '10px', color: '#888' }} />
          <input
            type="text"
            placeholder="Pesquisar usuário..."
            value={tempSearch}
            onChange={(e) => setTempSearch(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 10px 10px 40px',
              borderRadius: '20px',
              border: '1px solid #ddd',
              outline: 'none'
            }}
          />
        </div>

        <div className={styles.actionsHeader}>
          <p style={{ alignSelf: 'center', fontSize: '0.9rem', color: '#666', marginRight: '10px' }}>
            Qtd: <span style={{ fontWeight: 'bold', color: 'var(--green-700)' }}>{usuarios.length}</span>
          </p>

          <button className={styles.blueBtn} onClick={handleNovo} title="Adicionar Novo">
            <Add />
          </button>
          <button className={styles.blueBtn} onClick={() => window.history.back()} title="Voltar">
            <ArrowBack />
          </button>
        </div>
      </div>

      {mensagem && (
        <p style={{ color: mensagemErro ? '#f75a68' : '#00b37e', fontSize: '0.85rem', marginBottom: '10px' }}>{mensagem}</p>
      )}

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Nome</th>
              <th>E-mail</th>
              <th>Projetos</th>
              <th style={{ textAlign: 'center' }}>Status</th>
              <th style={{ textAlign: 'center' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {usuarios.map((u) => (
              <tr key={u.uid_usuario}>
                <td>{u.nome}</td>
                <td>{u.email}</td>
                <td>
                  {u.projetoVinculos && u.projetoVinculos.length > 0
                    ? u.projetoVinculos.map((v: any) => v.projeto?.nome).filter(Boolean).join(', ')
                    : <span style={{ color: '#999' }}>Nenhum vínculo</span>}
                </td>
                <td style={{ textAlign: 'center' }}>
                  <span style={{ color: u.ativo ? '#00b37e' : '#f75a68', fontWeight: 'bold' }}>
                    {u.ativo ? 'Ativo' : 'Inativo'}
                  </span>
                </td>
                <td>
                  <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                    <Edit fontSize="small" style={{ color: '#03c9fe', cursor: 'pointer' }} onClick={() => handleEditar(u)} />
                    <Mail fontSize="small" style={{ color: '#888', cursor: 'pointer' }} titleAccess="Reenviar convite" onClick={() => handleReenviarConvite(u)} />
                  </div>
                </td>
              </tr>
            ))}
            {usuarios.length === 0 && (
              <tr>
                <td colSpan={5} style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                  Nenhum usuário encontrado.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {formOpen && (
        <UsuarioForm
          usuario={usuarioEditando}
          onClose={() => setFormOpen(false)}
          onSaved={handleSalvo}
        />
      )}
    </div>
  );
};

export default UsuariosList;
